// extracted by mini-css-extract-plugin
export default {"table-container":"VirginEmailTemplatesTable_table-container__mvPjc"};